import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { grantPixelConsent, trackPageView } from "@/lib/metaPixel";

export default function PixelRouteTracker({ consent }) {
  const location = useLocation();

  useEffect(() => {
    if (consent === "accepted") {
      grantPixelConsent();
      trackPageView();
    }
  }, [consent, location.pathname, location.search, location.hash]);

  return null;
}
